import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {Form, Formik} from "formik";
import {useIntl} from 'react-intl';
import CommonPopup from "../../../_common/components/CommonPopup";
import {DataItem} from "../../../_common/components/DataItem/DataItem";
import {limitValueRangeFloat} from '../../../../../utils';
import {addEditCommission} from "../../_redux/customersActions";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";

export function CommissionPopup(cellContent) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [commission, setCommission] = useState('')

  const popupHeaderCommission = intl.formatMessage({
    id: 'customers-addEditCommission-popup-header',
    defaultMessage: 'Customer name',
  });
  const tooltip = intl.formatMessage({
    id: 'customers-column-addEditCommission',
    defaultMessage: 'Add/edit commission',
  });
  const fullHeader = `${popupHeaderCommission} ${cellContent?.customerID || ''}`

  const getContent = () => {

    return (
      <Formik
        initialValues={{
          commission: cellContent?.commission || '',
        }}
        onSubmit={() => null}
        enableReinitialize={true}
      >
        <Form>
          <DataItem
            fieldId={'commission'}
            onChange={(e) => {
              setCommission(e.target.value)
              limitValueRangeFloat(999, 0, 100)(e)
            }}
            inputContainerStyle={'w-75 mx-auto mb-12'}
          />
        </Form>
      </Formik>
    )
  };

  const addEditCommissionFunc = () => {
    dispatch(addEditCommission(cellContent.customerID, commission))
  };

  return (
    <CommonPopup
      icon={
        <img
          src={toAbsoluteUrl("/media/svg/Sale1_brandColor.svg")}
          alt="add-commission"
        />
      }
      buttonTooltip={tooltip}
      buttonOpenPopupClassName={'btn btn-icon btn-light btn-sm mx-3 custom-action-button'}
      header={fullHeader}
      content={() => getContent()}
      onConfirm={addEditCommissionFunc}
    />
  );
}